module.exports = __webpack_public_path__ + "img/03Jefferson.ae34d485.png";